import { IWidgetDefinition, IWidget } from '../../common/core';
import { IFieldDatePickerSettings, IFieldDatePickerState, FieldDatePickerData, widgetDefinition } from '../field-date-picker.widget/field-date-picker.widget.definition';

const template = require('./fuse-field-date-picker.html');
const styles = require('./fuse-field-date-picker.scss').toString();


class FuseFieldDatePickerData extends FieldDatePickerData {
}

export const FuseFieldDatePickerWidgetDefinition: IWidgetDefinition<FuseFieldDatePickerData, IFieldDatePickerSettings, IFieldDatePickerState> = {
  ...widgetDefinition,
  init(widget) {
    widget.data = new FuseFieldDatePickerData(widget);
  },
  template: template,
  styles: styles,
};
